import { render } from "./SitzungLeiten.vue?vue&type=template&id=12c23549&scoped=true"
import script from "./SitzungLeiten.vue?vue&type=script&lang=js"
export * from "./SitzungLeiten.vue?vue&type=script&lang=js"

import "./SitzungLeiten.vue?vue&type=style&index=0&id=12c23549&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12c23549"]])

export default __exports__